import { useContext } from 'react'
import { AdminAuthContext } from '../contexts/AdminAuthContext'

/**
 * Custom hook to access admin authentication context
 * Must be used within AdminAuthProvider
 */
export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext)
  if (!context) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider')
  }
  return context
}
